import actionTypes from "../../action_types/global_action_types";

function addAlert(type, message, delay = undefined) {
  return {
    type: actionTypes.ADD_ALERT,
    payload: {
      type,
      message,
      delay,
    },
  };
}

function removeAlert(alertKey) {
  return {
    type: actionTypes.REMOVE_ALERT,
    payload: {
      alertKey,
    },
  };
}
function cleanAlerts() {
  return {
    type: actionTypes.CLEAN_ALERTS,
    payload: {},
  };
}

export default {
  addAlert,
  removeAlert,
  cleanAlerts,
};
